/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const deleteProjectsProjectidSelectionsProjectselectionidPathProjectIdSchema = z.string()

export const deleteProjectsProjectidSelectionsProjectselectionidPathProjectSelectionIdSchema = z.string()

export const deleteProjectsProjectidSelectionsProjectselectionidStatus204Schema = z.string()

export const deleteProjectsProjectidSelectionsProjectselectionidStatus400Schema = z.string()

export const deleteProjectsProjectidSelectionsProjectselectionidStatus401Schema = z.string()

export const deleteProjectsProjectidSelectionsProjectselectionidStatus404Schema = z.string()

export const deleteProjectsProjectidSelectionsProjectselectionidStatus500Schema = z.string()

export const deleteProjectsProjectidSelectionsProjectselectionidResponseSchema = deleteProjectsProjectidSelectionsProjectselectionidStatus204Schema

export const deleteProjectsProjectidSelectionsProjectselectionidErrorSchema = z.union([deleteProjectsProjectidSelectionsProjectselectionidStatus400Schema, deleteProjectsProjectidSelectionsProjectselectionidStatus401Schema, deleteProjectsProjectidSelectionsProjectselectionidStatus404Schema, deleteProjectsProjectidSelectionsProjectselectionidStatus500Schema])
